import React, { useEffect, useState } from "react";
import moment from "moment";
import FavIcon from "./FavIcon";
import ViewIcon from "./ViewIcon";
import MemoTagItem from "./MemoTagItem";
import { useHistory } from "react-router-dom";

const MemoItem = ({ content, tags, created, fav, mid, updated }) => {
  const history = useHistory();
  const [mTag, setMTag] = useState([]);
  const [showFav, setShowFav] = useState(false);
  useEffect(() => {
    if (tags) {
      const theTag = JSON.parse(tags);
      setMTag(theTag);
    }
  }, [tags]);
  return (
    <div
      onClick={() => {
        history.push(`/dashboard/memo/${mid}`);
      }}
      style={{ width: "16rem" }}
      className="bg-white rounded-lg px-4 py-3 shadow-sm cursor-pointer transition duration-500 ease-in-out transform hover:-translate-y-1"
      onMouseEnter={() => setShowFav(true)}
      onMouseLeave={() => setShowFav(false)}
    >
      <div className="flex justify-between items-start">
        <p className="p-0 m-0 text-gray-500 mb-1">
          {moment(created).calendar()}
        </p>
        <div className="flex">
          <FavIcon fav={fav} mid={mid} showFav={showFav} />
          <ViewIcon
            content={content}
            updated={updated}
            upd={moment(created).calendar()}
            mid={mid}
          />
        </div>
      </div>
      <p className="p-0 m-0 my-2 text-gray-600 overflow-hidden text-ov">
        {content}
      </p>
      <div className="mt-1 flex flex-wrap">
        {mTag.length !== 0
          ? mTag.map((e) => {
              return (
                <MemoTagItem key={e.tid} tagName={e.tag_name} tid={e.tid} />
              );
            })
          : null}
      </div>
    </div>
  );
};

export default MemoItem;
